var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.626,
    height: 10,
    viewBox: "0 0 11.626 10",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.568 4.565l4 4 4-4A1.887 1.887 0 0 0 7.9 1.9L6.57 3.231 5.236 1.9a1.887 1.887 0 1 0-2.668 2.665zm3.558-3.558l.445.445.445-.445a3.145 3.145 0 1 1 4.447 4.447L7.016 9.9a.629.629 0 0 1-.89 0L1.678 5.454a3.145 3.145 0 1 1 4.447-4.447z",
    transform: "translate(-.757 -.086)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/heart.4b54ce516118a90682ee9408dd689267.svg";